export const SET_LAB_DATA = 'SET_LAB_DATA'
export const SET_LAB_ADDRESS_DATA = 'SET_LAB_ADDRESS_DATA'
export const SET_LAB_TEST_DATA = 'SET_LAB_TEST_DATA'